import { IChangeTracking } from "../../../changeTracking/iChangeTracking";
import { RequestMaterials } from "./requestMaterials";
import { RequestPackages } from "./requestPackages";

export class RequestAssignedMaterialToPackage implements IChangeTracking {
    private _current: any;
    private _requestMaterials: RequestMaterials;
    private _requestPackages: RequestPackages[] = [];
    constructor(private _model: any) {
        this._current = this._model ? angular.copy(this._model) : {};
        this.loadRequestMaterials();
        this.loadRequestPackages();
    }

    private loadRequestMaterials(): void {

        if (this._current.requestMaterialEdit !== undefined && this._current.requestMaterialEdit != null) {

            this._requestMaterials = new RequestMaterials(this._current.requestMaterialEdit);
        } else {
            this._requestMaterials = undefined;
        }
    }

    private loadRequestPackages(): void {

        if (this._current.packages !== undefined && this._current.packages !== null && this._current.packages.length > 0) {
            this._requestPackages = [];
            for (let pkgs of this._current.packages) {
                this._requestPackages.push(new RequestPackages(pkgs));
            }
        }
    }

    

    get assignedPc(): number {
        return this._current.assignedPC;
    }

    set assignedPc(value: number) {
        this._current.assignedPC = value;
    }

    get requestMaterials(): RequestMaterials {
        return this._requestMaterials;
    }

    set requestMaterials(val: RequestMaterials) {
        this._requestMaterials = val;
        
    }

    get requestPackages(): RequestPackages[] {
        return this._requestPackages;

    }

    set requestPackages(val : RequestPackages[]) {
        this._requestPackages = val;
        
    }


    hasChanges(): boolean {
        return !angular.equals(this._current, this._model);
    }

    revert(): void {
        this._current = angular.copy(this._model);

    }

    commit(): void {
        this._model = angular.copy(this._current);
    }

    toJson(): any {

        return this._current;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/models/requestAssignedMaterialToPackage.ts
 **/